import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["accountNumber", "submitButton"]

  connect() {
    this.validateAccountNumber()
  }

  validateAccountNumber() {
    const accountNumberField = this.accountNumberTarget
    const submitButton = this.submitButtonTarget
    const correctAccountNumber = accountNumberField.dataset.accountNumber
    
    // Enable the button only when the account number matches
    if (accountNumberField.value.toUpperCase() === correctAccountNumber) {
      submitButton.disabled = false
    } else {
      submitButton.disabled = true
    }
  }
}